import(/* webpackMode: "eager" */ "/codebuild/output/src1756345992/src/actions-runner/_work/eon-service/eon-service/frontend/node_modules/@mui/material/Box/index.js");
